import {
  CIVILBUDGETCONTROLMATERIAL_LOADING,
  GET_CIVILBUDGETCONTROLMATERIAL,
  GET_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  GET_CIVILBUDGETCONTROLMATERIAL_FAIL,
  ADD_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  ADD_CIVILBUDGETCONTROLMATERIAL_FAIL,
  DELETE_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  DELETE_CIVILBUDGETCONTROLMATERIAL_FAIL,
  UPDATE_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  UPDATE_CIVILBUDGETCONTROLMATERIAL_FAIL,
  CIVILBUDGETCONTROLMATERIAL_RESET
} from "./actionType";

const INIT_STATE = {
  civilBudgetControlMaterials: [],
  error: {},
};

const CivilBudgetControlMaterial = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILBUDGETCONTROLMATERIAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETCONTROLMATERIAL:
          return {
            ...state,
            civilBudgetControlMaterials: action.payload.data,
            isCivilBudgetControlMaterialCreated: false,
            isCivilBudgetControlMaterialSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILBUDGETCONTROLMATERIAL_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETCONTROLMATERIAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilBudgetControlMaterialCreated: false,
            isCivilBudgetControlMaterialSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILBUDGETCONTROLMATERIAL: {
      return {
        ...state,
        isCivilBudgetControlMaterialCreated: false,
        loading: true,
      };
    }

    case CIVILBUDGETCONTROLMATERIAL_LOADING: {
      return {
        ...state,
        isCivilBudgetControlMaterialCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILBUDGETCONTROLMATERIAL_SUCCESS:
      return {
        ...state,
        isCivilBudgetControlMaterialCreated: true,
        loading: false,
        civilBudgetControlMaterials: [action.payload.data, ...state.civilBudgetControlMaterials],
      };

    case ADD_CIVILBUDGETCONTROLMATERIAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILBUDGETCONTROLMATERIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetControlMaterials: state.civilBudgetControlMaterials.filter(
          civilCivilBudgetControlMaterial => civilCivilBudgetControlMaterial.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILBUDGETCONTROLMATERIAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILBUDGETCONTROLMATERIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgetControlMaterials: state.civilBudgetControlMaterials.map(civilCivilBudgetControlMaterial =>
          civilCivilBudgetControlMaterial.id.toString() === action.payload.data.id.toString() ? { ...civilCivilBudgetControlMaterial, ...action.payload.data } : civilCivilBudgetControlMaterial
        ),
      };

    case UPDATE_CIVILBUDGETCONTROLMATERIAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILBUDGETCONTROLMATERIAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilBudgetControlMaterial;